import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { SecurityService } from "common";
//import { Inject } from '@angular/core';

export function SecurityServiceFactory(document: Document, http: HttpClient, router: Router): SecurityService {
  const service = new SecurityService(document, http, router);
  service.apiClientType = 'SenderId';
  return service;
}